// LiveEdge channelInfo ↔ 명세의 평평한 채널 칸.
// 대부분의 유형은 그대로지만 Custom 은 {type, filePath, value:{interval, ip, port, user, database, databaseType}} 로
// 한 단계 중첩된다 — 명세·폼에서는 펴서 다루고 Edge 로 보낼 때 다시 중첩한다.

const CUSTOM_VALUE_KEYS = ['interval', 'ip', 'port', 'user', 'database', 'databaseType']

/** 명세 칸 → Edge 로 보낼 channelInfo */
export function toEdgeChannelInfo(channelType: string, channel: Record<string, unknown>): Record<string, unknown> {
  if (channelType !== 'Custom') return channel
  const value = Object.fromEntries(CUSTOM_VALUE_KEYS.filter(k => k in channel).map(k => [k, channel[k]]))
  return { type: channel.type || 'DATABASE', filePath: channel.filePath ?? '', value }
}

/** Edge channelInfo → 평평하게 (value 안의 칸을 위로, 표시용 connection 은 뺀다) */
export function flattenEdgeChannelInfo(info: Record<string, unknown>): Record<string, unknown> {
  const { value, ...rest } = info
  const flat = value && typeof value === 'object' && !Array.isArray(value) ? { ...rest, ...(value as Record<string, unknown>) } : { ...info }
  delete flat.connection
  return flat
}
